module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-plus-fill-13798d7c.svg";